/**
 =========================================================
 * Material Dashboard 2 React - v2.2.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2023 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import React, {useEffect, useState} from "react";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import {useDispatch, useSelector} from "react-redux";
import {
  cargoOwnerCarrierEdit,
  cargoOwnerDiscountAdd, cargoOwnerDiscountEdit, cargoOwnerInfo,
  getAllWarehouseList, kitFilter, ownerSelected
} from "../../../../actions/inventory/inventoryAction";
import {noop} from "lodash";
import {Logout, onErrorAlert, onSuccessAlert} from "../../../../actions";
import {
  Chip,
  ClickAwayListener,
  FormControl,
  FormControlLabel,
  FormGroup, FormHelperText,
  FormLabel,
  Input,
  Radio,
  RadioGroup,
  Slider,
  Stack, Tooltip, tooltipClasses
} from "@mui/material";
import Grid from "@mui/material/Grid";
import Checkbox from "@mui/material/Checkbox";
import {createTheme, styled, ThemeProvider} from '@mui/material/styles'
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import MDButton from "../../../../components/MDButton";
import {LoadingButton} from "@mui/lab";
import LocalStorage from "../../../../utils/LocalStorage";
import {useNavigate} from "react-router-dom";
import {
  userWHMpCfgInfo, userWHMpCfgList,
  userWHMpCfgModify,
  userWHMpCfgReset,
  userWHMpCfgSave
} from "../../../../actions/userWHMp/userWHMpAction";
import {checkPermission, PERMISSION_DICT} from "../../../../utils/Users_Roles_Permission";
import {customerInfo} from "../../../../actions/customer/customerAction";
import {userWHMpReducer} from "../../../../reducers/userWHMp/userWHMpReducer";
import Autocomplete from "@mui/material/Autocomplete";
import MDInput from "../../../../components/MDInput";
import {useDebounce} from "use-debounce";
import IconButton from "@mui/material/IconButton";
import InfoIcon from '@mui/icons-material/Info';
import CircularProgress from "@mui/material/CircularProgress";
import { v4 as uuidv4 } from 'uuid';
import {useTranslation} from "react-i18next";


const muiTheme = createTheme({
  slider: {
    trackColor: "yellow",
    selectionColor: "green"
  }
});



function PlatformSettings({type,setType,setPageLoading,openSplitOrderEdit,setOpenSplitOrderEdit,pageFormData,data,setTotal,setList}) {
  const darkMode = useSelector(state => state?.common?.darkMode,(prev, next) => prev === next)
  const haveCard = useSelector(state => state?.system?.haveCard,(prev, next) => prev === next)
  const warehouseList = useSelector(state => state?.inventory?.warehouseList,(prev, next) => prev === next)
  const userWHMpCfg = useSelector(state => state?.userWHMpReducer?.userWHMpCfg,(prev, next) => prev === next)
  const {t} = useTranslation();
  const [allWarehouses, setAllWarehouses] = useState([])
  const [ownerList ,setOwnerList] =useState([])
  const [ownerId, setOwnerId] = useState(null)
  const [inputOwnerValue,setInputOwnerValue] = useState()
  const [ownerValue] = useDebounce(inputOwnerValue, 500);

  const [tabValue, setTabValue] = useState('domestic');

  const [allowAllWarehouse, setAllowAllWarehouse] = useState(true);
  const [allowAllWarehouseInter, setAllowAllWarehouseInter] = useState(true);

  const [allowSplitOrders, setAllowSplitOrders] = useState(false);
  const [allowSplitOrdersInter, setAllowSplitOrdersInter] = useState(false);

  const [allowCrossBorderShipping, setAllowCrossBorderShipping] = useState(true);

  const [splitInvPriority, setSplitInvPriority] = useState('inventory_first');
  const [splitInvPriorityInter, setSplitInvPriorityInter] = useState('inventory_first');

  const [maxSplit, setMaxSplit] = useState(1);


  const [selectedList, setSelectedList] = useState([])
  const [selectedListInter, setSelectedListInter] = useState([])

  const [splitValue, setSplitValue] = useState(5);
  const [splitValueInter, setSplitValueInter] = useState(5);

  const [isOpenInfo, setIsOpenInfo] = React.useState(false);
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const nav = useNavigate()


  useEffect(()=>{

    if(ownerValue && type === 'Add'){
      const axiosPost = async () => {
        await dispatch(ownerSelected({condition: ownerValue, userName: LocalStorage.getItem('username')}, (data)=>setOwnerList(data)))
      }
      axiosPost().then()
    } else {
      setOwnerList([])
    }
  },[ownerValue])



  useEffect(() => {

    setLoading(true)
    if (type === 'Add' && openSplitOrderEdit){
      setAllowAllWarehouse(true)
      setAllowSplitOrders(false)
      setAllowCrossBorderShipping(true)
      setLoading(false)
    }


    if(!openSplitOrderEdit){
      setLoading(false)
      setOpenSplitOrderEdit(false)
      dispatch(userWHMpCfgReset())
    }

    if(openSplitOrderEdit){
      const axiosPost= async () => {
        if (type !== "Add"){
          if(checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
            await dispatch(ownerSelected({condition: data?.ownerId, userName: LocalStorage.getItem('username')}, (data)=>setOwnerId(data[0])))
            await dispatch(userWHMpCfgInfo({
              // userName: LocalStorage.getItem('username'),
              ownerId: data?.ownerId,
              // pageNum:1,
              // pageSize:10
            }, onInfoSuccess,onError))
          }else {
            await dispatch(userWHMpCfgInfo({
              // userName: LocalStorage.getItem('username'),
              ownerId: LocalStorage.getItem('ownerId'),
              // pageNum:1,
              // pageSize:10
            }, onInfoSuccess,onError))
          }
        }
      }
      axiosPost().then()
    }

  }, [openSplitOrderEdit])


  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };


  const handleSplitPriorityChange = (event) => {
    if (type!== 'Preview'){
      setSplitInvPriority(event.target.value);
    }
  };

  const handleMaxSplitChange = (event) => {
    if (type!== 'Preview'){
      setMaxSplit(event.target.value);
    }
  };


  const handleSplitPriorityChangeInter = (event) => {
    setSplitInvPriorityInter(event.target.value);
  };


  const onSuccess = async (msg) => {
    dispatch(onSuccessAlert(t(msg)))
    setLoading(false)
    // // clearAllFields()
    setOpenSplitOrderEdit(false)
    setPageLoading(true)
    let formData = {}
    if (pageFormData) {
      formData = pageFormData
    } else {
      return nav('/')
    }
    await dispatch(userWHMpCfgList(formData, onSearchSuccess,onError))

  }
  const onSearchSuccess = (datax) => {

    setTotal(datax?.total ? datax?.total:0)
    setList(datax?.rows ? datax?.rows.map((item, index) => {
      return { ...item, id: uuidv4() };
    }):[])

    setPageLoading(false)
  }


  const onInfoSuccess = (data) => {
    if (data?.data?.designatedWarehouse[0] === "*"){
      setAllowAllWarehouse(true)
      setAllWarehouses(warehouseList)
    }else {
      setAllowAllWarehouse(false)
      setSelectedList(data?.data?.designatedWarehouse)
    }
    setAllowSplitOrders(data?.data?.orderSplitFlag === 'Y')

    if (data?.data?.crossBorderFlag === 'Y' || data?.data?.crossBorderFlag === 'N'){
      setAllowCrossBorderShipping(data?.data?.crossBorderFlag === 'Y')
    }
    setSplitInvPriority(data?.data?.splitRule)
    setMaxSplit(data?.data?.maxSplitNum)

    setLoading(false)
  }

  useEffect(() => {
    if (allowSplitOrders === true) {
      !splitInvPriority && setSplitInvPriority('inventory_first')
      !maxSplit && setMaxSplit(1)
    }
  }, [allowSplitOrders]);

  const onError = (msg, code) => {
    dispatch(onErrorAlert(msg))
    setLoading(false)
    if (code === 401) {
      dispatch(Logout(noop))
      nav('/')
    }
  }

  const onSubmit = (data) => {

    let internationalRule = {}
    let domesticRule = {}

    //inter Warehouse
    if (allowAllWarehouseInter === true){
      internationalRule.designatedWarehouse = ["*"]
    }else {
      if (selectedListInter.length === 0 ){
        dispatch(onErrorAlert(t('WarehousePage.WarehouseMappings.please select at least one warehouse in international rules.')))
        setLoading(false)
        return
      }else {
        internationalRule.designatedWarehouse = selectedListInter
      }
    }

    //inter Split order

    if (allowSplitOrdersInter === true){
      internationalRule.orderSplitFlag = "Y"
      internationalRule.splitRule = splitInvPriorityInter
      internationalRule.maxSplitNum = splitValueInter
    }else {
      internationalRule.orderSplitFlag = "N"
    }

    //domestic Warehouse
    if (allowAllWarehouse === true){
      domesticRule.designatedWarehouse = ["*"]
    }else {
      if (selectedList.length === 0 ){
        dispatch(onErrorAlert(t('WarehousePage.WarehouseMappings.please select at least one warehouse in warehouse rules.')))
        setLoading(false)
        return
      }else {
        domesticRule.designatedWarehouse = selectedList
      }
    }

    //domestic Split order

    if (allowSplitOrders === true){
      domesticRule.orderSplitFlag = "Y"
      domesticRule.splitRule = splitInvPriority
      domesticRule.maxSplitNum = splitValue
    }else {
      domesticRule.orderSplitFlag = "N"
    }


    // let record = {
    //   internationalRule:internationalRule,
    //   domesticRule:domesticRule,
    //   userName:LocalStorage.getItem("username"),
    //   ownerId:owner?.ocpOwnerId,
    // }

    let record = {
      designatedWarehouse: domesticRule.designatedWarehouse,
        // userName:LocalStorage.getItem("username"),
    }


    if (allowSplitOrders === true && (!splitInvPriority || !maxSplit)){
      dispatch(onErrorAlert(t('WarehousePage.WarehouseMappings.If you wish to split order, please select split priority and maximum split number.')))
      return
    }



    if (allowSplitOrders === true){
      record.orderSplitFlag = "Y"
      record.splitRule = splitInvPriority
      record.maxSplitNum = maxSplit
    }else {
      record.orderSplitFlag = "N"
    }
    record.crossBorderFlag = allowCrossBorderShipping ? "Y":"N"

    if(type === 'Add'){
      if (checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
        if (!!ownerId){
          record.ownerId = ownerId.ownerId
        }else {
          setLoading(false)
          dispatch(onErrorAlert(t("WarehousePage.WarehouseMappings.please select one cargo owner to add split rules.")))
          return
        }
      }else {
        record.ownerId = LocalStorage.getItem("ownerId")
      }
      dispatch(userWHMpCfgSave(record, onSuccess, onError))
    }

    if(type === 'Edit'){
      if (checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
        if (!!ownerId){
          record.ownerId = ownerId.ownerId
        }else {
          setLoading(false)
          dispatch(onErrorAlert(t("WarehousePage.WarehouseMappings.please select one cargo owner to add split rules.")))
          return
        }
      }else {
        record.ownerId = LocalStorage.getItem("ownerId")
      }
      dispatch(userWHMpCfgModify(record, onSuccess, onError))
    }
  }




  const handleSelect = (e, warehouse) => {
    if (e.target.checked) {
      setSelectedList((prevState) => ([...prevState, warehouse]))
    } else {
      setSelectedList((prevState) => ([...selectedList].filter(item => item !== warehouse)))
    }
  }

  const handleSelectInter = (e, warehouse) => {
    if (e.target.checked) {
      setSelectedListInter((prevState) => ([...prevState, warehouse]))
    } else {
      setSelectedListInter((prevState) => ([...selectedListInter].filter(item => item !== warehouse)))
    }
  }

  const CustomWidthTooltip = styled(({ className, ...props }) => (
      <Tooltip {...props} classes={{ popper: className }} />
  ))({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: 400,
    },
  });

  return (
      <Card sx={{boxShadow: "none", minHeight:"428px",justifyContent: "space-between"}}>
        <MDBox>
          {
              checkPermission(PERMISSION_DICT.QueryOwnerInfo) &&
              <MDBox pt={1} pb={2} px={2} lineHeight={1.25}>
                <Grid width='100%' justifyContent='space-between' alignItems='center' spacing={2} mt={5}>
                  <FormControl fullWidth>
                    <Autocomplete
                        required
                        disablePortal={false}
                        disabled={type!== "Add"}
                        options={ownerList}
                        getOptionLabel={(option) => `ID: ${option?.ownerId} Name: ${option?.ownerName}`}
                        isOptionEqualToValue={(option, value) => option?.ownerId === value?.ownerId}
                        value={ownerId}
                        onChange={(e, v) => setOwnerId(v)}
                        onInputChange = {(event, newInputValue)=> setInputOwnerValue(newInputValue)}
                        renderInput={(params) =>
                            <MDInput
                                variant="standard"
                                {...params}
                                label={t('WarehousePage.WarehouseMappings.Owner')}
                                required
                                InputLabelProps={{ shrink: true }}
                            />}
                    />
                    <FormHelperText
                        sx={{ fontWeight: 'medium' }}></FormHelperText>
                  </FormControl>
                </Grid>
              </MDBox>
          }

          {type === 'Preview' ?
              <MDBox>
                <MDBox pt={1} pb={2} px={2} lineHeight={1.25}>
                  <MDTypography variant="caption" fontWeight="bold" textTransform="uppercase">
                    {t('WarehousePage.WarehouseMappings.warehouse setting')}
                  </MDTypography>
                  <br/>
                  <MDTypography variant="button" fontWeight="regular" color="text">
                    {t('WarehousePage.WarehouseMappings.Shipping warehouses allowed:')}
                  </MDTypography>
                  {
                    loading === false ?
                      <MDBox pr={4}>
                        {
                          allowAllWarehouse === true?
                              <MDBox  sx={{display:"flex", flexWrap: "wrap"}}>
                                {
                                  allWarehouses.map((ele,index)=>{
                                    return(
                                        <MDBox ml={1} mt={1}>
                                          <ThemeProvider theme={muiTheme}>
                                            <Chip color="primary" label={ele.dictLabel} size="small" />
                                          </ThemeProvider>
                                        </MDBox>
                                    )
                                  })
                                }
                              </MDBox>
                              :
                              <MDBox sx={{display:"flex", flexWrap: "wrap"}}>
                                {
                                  selectedList.map((ele,index)=>{
                                    return(
                                        <MDBox ml={1} mt={1}>
                                          <ThemeProvider theme={muiTheme}>
                                            <Chip color="primary" label={warehouseList?.find((e)=>e.dictValue === ele).dictLabel} size="small" />
                                          </ThemeProvider>
                                        </MDBox>
                                    )
                                  })
                                }
                              </MDBox>
                        }
                      </MDBox>:
                        <MDBox>
                          <CircularProgress />
                        </MDBox>
                        
                  }

                  <MDBox mt={3}>
                    <MDTypography variant="caption" fontWeight="bold"  textTransform="uppercase">
                      {t('WarehousePage.WarehouseMappings.Split Order Setting')}
                    </MDTypography>
                  </MDBox>

                  <MDBox>
                    <Grid container mt={1}>
                      <Grid item xs={6} mt={1}>
                        <MDTypography variant="button" fontWeight="regular" color="text">
                          {t('WarehousePage.WarehouseMappings.Allow Split Orders')}
                        </MDTypography>
                      </Grid>
                      <Grid item xs={6} mt={1}>
                        {
                          loading ? <MDBox>Loading...</MDBox> :
                              allowSplitOrders? <MDBox color={"green"}>{t('YES')}</MDBox> :<MDBox color={"red"}>{t('NO')}</MDBox>
                        }
                      </Grid>
                      {
                        allowSplitOrders && <Grid container mt={1}>
                            <Grid item xs={6} mt={1}>
                              <MDTypography variant="button" fontWeight="regular" color="text">
                                {t('WarehousePage.WarehouseMappings.Split Priority')}
                              </MDTypography>
                            </Grid>
                            <Grid item xs={6} mt={1}>
                              {t(`WarehousePage.WarehouseMappings.${splitInvPriority?.toUpperCase()?.slice(0, -6)}`)}
                            </Grid>
                            <Grid item xs={6} mt={1}>
                              <MDTypography variant="button" fontWeight="regular" color="text">
                                {t('WarehousePage.WarehouseMappings.Max Split Number')}
                              </MDTypography>
                            </Grid>
                            <Grid item xs={6} mt={1}>
                              {maxSplit}
                            </Grid>
                          </Grid>
                      }
                      <Grid item xs={6} mt={1}>
                        <MDTypography variant="button" fontWeight="regular" color="text">
                          {t('WarehousePage.WarehouseMappings.Enable Cross-Border Shipping')}
                        </MDTypography>
                      </Grid>
                      <Grid item xs={6} mt={1}>
                        {
                          loading ? <MDBox>Loading...</MDBox> :
                              allowCrossBorderShipping? <MDBox color={"green"}>{t('YES')}</MDBox> :<MDBox color={"red"}>{t('NO')}</MDBox>
                        }
                      </Grid>
                    </Grid>

                  </MDBox>



                </MDBox>

              </MDBox>
              :
              <MDBox>
                {
                  tabValue === 'domestic' ?
                      <MDBox pt={1} pb={2} px={2} lineHeight={1.25}>
                        <MDTypography variant="caption" fontWeight="bold" textTransform="uppercase">
                          {t('WarehousePage.WarehouseMappings.warehouse setting')}
                        </MDTypography>
                        <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                          <MDBox mt={0.5}>
                            <ThemeProvider theme={muiTheme}>
                              <Switch disabled={type === "Preview"} checked={allowAllWarehouse} onChange={() => setAllowAllWarehouse(!allowAllWarehouse)}/>
                            </ThemeProvider>
                          </MDBox>
                          <MDBox width="80%" ml={0.5}>
                            <MDTypography variant="button" fontWeight="regular" color="text">
                              {t('WarehousePage.WarehouseMappings.Allow shipping from all warehouses')}
                            </MDTypography>
                          </MDBox>
                          <MDBox width="20%" display="flex" justifyContent="flex-end">
                            <Tooltip title={t('WarehousePage.WarehouseMappings.In default, Allow shipping from all warehouses')} arrow>
                              <IconButton >
                                <InfoIcon fontSize="small" style={darkMode ? {color: 'white'} : {color: 'text'}}/>
                              </IconButton>
                            </Tooltip>
                          </MDBox>
                        </MDBox>
                        {
                            allowAllWarehouse === false &&
                            <FormControl>
                              <MDTypography variant="button" fontWeight="regular" color="text" my={1}>
                                {t('WarehousePage.WarehouseMappings.Select warehouses for shipping :')}
                              </MDTypography>
                              <FormGroup>
                                <Grid container>
                                  {warehouseList.map((warehouse, index) => {
                                    return (
                                        <Grid item md={6} xs={12} key={index}>
                                          <MDBox sx={{
                                            border: (selectedList?.indexOf(warehouse.dictValue) !== -1 ? "2px solid #3d97ef" : "2px solid lightGray"),
                                            paddingLeft: "10px",
                                            borderRadius: "10px",
                                            marginRight: "3px",
                                            marginTop: "3px"
                                          }}>
                                            <FormControlLabel control={<Checkbox size="small"/>}
                                                              checked={selectedList?.indexOf(warehouse.dictValue) !== -1}
                                                              disabled={type === "Preview"}
                                                              onChange={
                                                                (e) => {
                                                                  handleSelect(e, warehouse.dictValue)
                                                                }} label={<MDBox style={{fontSize:"13px"}}>{warehouse.dictLabel}</MDBox>}/>
                                          </MDBox>
                                        </Grid>
                                    )
                                  })}
                                </Grid>
                              </FormGroup>
                            </FormControl>

                        }
                        <MDBox mt={3}>
                          <MDTypography variant="caption" fontWeight="bold"  textTransform="uppercase">
                            {t('WarehousePage.WarehouseMappings.Split Order Setting')}
                          </MDTypography>
                        </MDBox>
                        <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                          <MDBox mt={0.5}>
                            <ThemeProvider theme={muiTheme}>
                              <Switch checked={allowSplitOrders} disabled={type === 'Preview'} onChange={() => setAllowSplitOrders(!allowSplitOrders)}/>
                            </ThemeProvider>
                          </MDBox>
                          <MDBox width="80%" ml={0.5}>
                            <MDTypography variant="button" fontWeight="regular" color="text">

                              {t('WarehousePage.WarehouseMappings.Allow Split Orders')}
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                        {
                            allowSplitOrders === true &&
                            <MDBox>
                              <MDBox>
                                <FormControl sx={{width:"100%"}}>
                                  <MDBox   sx={{display:"flex", alignItems:"center", justifyContent:"space-between", width:"100%"}}>
                                    <MDTypography variant="button" fontWeight="regular" color="text">
                                      {t('WarehousePage.WarehouseMappings.Priority')}:
                                    </MDTypography>
                                    <MDBox>
                                      <CustomWidthTooltip  title={<div
                                          style={{display: "flex", flexDirection: "column", alignItems: "start"}}>
                                        <div style={{display: "flex"}}>
                                          <div style={{width:"90px"}}>
                                            {t('WarehousePage.WarehouseMappings.Distance')}:
                                          </div>
                                          <div>
                                            {t('WarehousePage.WarehouseMappings.Minimum shipping distance (default)')}
                                          </div>
                                        </div>
                                        <div style={{display: "flex"}}>
                                          <div style={{width:"90px"}}>
                                            {t('WarehousePage.WarehouseMappings.Inventory')}:
                                          </div>
                                          <div>
                                            {t('WarehousePage.WarehouseMappings.Minimum split times')}
                                          </div>
                                        </div>
                                      </div>} arrow>
                                        <IconButton>
                                          <InfoIcon fontSize="small"
                                                    style={darkMode ? {color: 'white'} : {color: 'text'}}/>
                                        </IconButton>
                                      </CustomWidthTooltip>
                                    </MDBox>
                                  </MDBox>
                                  <ThemeProvider theme={muiTheme}>
                                    <MDBox>
                                      <RadioGroup
                                          row
                                          aria-labelledby="demo-controlled-radio-buttons-group"
                                          name="controlled-radio-buttons-group"
                                          value={splitInvPriority}
                                          onChange={handleSplitPriorityChange}
                                      >
                                        <MDBox>
                                          <FormControlLabel value="inventory_first" control={<Radio size="small"/>}
                                                            label={
                                                              <MDTypography variant="button" fontWeight="regular"
                                                                            color="text">
                                                                {t('WarehousePage.WarehouseMappings.Inventory')}
                                                              </MDTypography>}
                                          />
                                        </MDBox>
                                        <MDBox ml={2}>
                                          <FormControlLabel value="distance_first" control={<Radio size="small"/>}
                                                            label={
                                                              <MDTypography variant="button" fontWeight="regular"
                                                                            color="text">
                                                                {t('WarehousePage.WarehouseMappings.Distance')}
                                                              </MDTypography>}
                                          />
                                        </MDBox>


                                      </RadioGroup>
                                    </MDBox>
                                  </ThemeProvider>
                                </FormControl>
                              </MDBox>
                              <MDBox mt={2}>
                                <FormControl>
                                  <MDTypography variant="button" fontWeight="regular" color="text">
                                    {t('WarehousePage.WarehouseMappings.Maximum split')}:
                                  </MDTypography>
                                  <ThemeProvider theme={muiTheme}>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                        name="controlled-radio-buttons-group"
                                        value={maxSplit}
                                        onChange={handleMaxSplitChange}
                                    >
                                      <FormControlLabel value={1} control={<Radio size="small"/>}
                                                        label={
                                                          <MDTypography variant="button" fontWeight="regular" color="text">
                                                            1
                                                          </MDTypography>}
                                      />
                                      <FormControlLabel value={2} control={<Radio size="small"/>}
                                                        label={
                                                          <MDTypography variant="button" fontWeight="regular" color="text">
                                                            2
                                                          </MDTypography>}
                                      />
                                      <FormControlLabel value={3} control={<Radio size="small"/>}
                                                        label={
                                                          <MDTypography variant="button" fontWeight="regular" color="text">
                                                            3
                                                          </MDTypography>}
                                      />
                                    </RadioGroup>
                                  </ThemeProvider>
                                </FormControl>
                              </MDBox>
                            </MDBox>
                        }
                        <MDBox mt={3}  sx={{display:"flex", alignItems:"center", justifyContent:"space-between", width:"100%"}}>
                          <MDTypography variant="caption" fontWeight="bold"  textTransform="uppercase">
                            {t('WarehousePage.WarehouseMappings.Shipping Policy')}
                          </MDTypography>
                          <MDBox>
                            <CustomWidthTooltip  title={<div
                                style={{display: "flex", flexDirection: "column", alignItems: "start"}}>
                              {t('WarehousePage.WarehouseMappings.Enable Cross-Border Shipping means that if the warehouse in the destination country is out of stock, shipments will be fulfilled from another country.')}
                            </div>} arrow>
                              <IconButton>
                                <InfoIcon fontSize="small"
                                          style={darkMode ? {color: 'white'} : {color: 'text'}}/>
                              </IconButton>
                            </CustomWidthTooltip>
                          </MDBox>
                        </MDBox>
                        <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                          <MDBox mt={0.5}>
                            <ThemeProvider theme={muiTheme}>
                              <Switch checked={allowCrossBorderShipping} disabled={type === 'Preview'} onChange={() => setAllowCrossBorderShipping(!allowCrossBorderShipping)}/>
                            </ThemeProvider>
                          </MDBox>
                          <MDBox width="80%" ml={0.5}>
                            <MDTypography variant="button" fontWeight="regular" color="text">

                              {t('WarehousePage.WarehouseMappings.Enable Cross-Border Shipping')}
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                      :
                      <MDBox> </MDBox>
                  // <MDBox pt={1} pb={2} px={2} lineHeight={1.25}>
                  //   <MDTypography variant="caption" fontWeight="bold" textTransform="uppercase">
                  //     International Warehouse setting
                  //   </MDTypography>
                  //   <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                  //     <MDBox mt={0.5}>
                  //       <ThemeProvider theme={muiTheme}>
                  //         <Switch checked={allowAllWarehouseInter} onChange={() => setAllowAllWarehouseInter(!allowAllWarehouseInter)}/>
                  //       </ThemeProvider>
                  //     </MDBox>
                  //     <MDBox width="80%" ml={0.5}>
                  //       <MDTypography variant="button" fontWeight="regular" color="text">
                  //         Allow shipping from all warehouses
                  //       </MDTypography>
                  //     </MDBox>
                  //   </MDBox>
                  //   {
                  //       allowAllWarehouseInter === false &&
                  //       <FormControl>
                  //         <MDTypography variant="button" fontWeight="regular" color="text" my={1}>
                  //           Select warehouses for shipping :
                  //         </MDTypography>
                  //         <FormGroup>
                  //           <Grid container>
                  //             {warehouseList.map((warehouse, index) => {
                  //               return (
                  //                   <Grid item md={6} xs={12} key={index}>
                  //                     <MDBox sx={{
                  //                       border: (selectedListInter?.indexOf(warehouse.dictValue) !== -1 ? "2px solid #3d97ef" : "2px solid lightGray"),
                  //                       paddingLeft: "10px",
                  //                       borderRadius: "10px",
                  //                       marginRight: "3px",
                  //                       marginTop: "3px"
                  //                     }}>
                  //                       <FormControlLabel control={<Checkbox size="small"/>}
                  //                                         checked={selectedListInter?.indexOf(warehouse.dictValue) !== -1}
                  //                                         onChange={
                  //                                           (e) => {
                  //                                             handleSelectInter(e, warehouse.dictValue)
                  //                                           }} label={<div style={{fontSize:"13px"}}>{warehouse.dictLabel}</div>}/>
                  //                     </MDBox>
                  //                   </Grid>
                  //               )
                  //             })}
                  //           </Grid>
                  //         </FormGroup>
                  //       </FormControl>
                  //
                  //   }
                  //   <MDBox mt={3}>
                  //     <MDTypography variant="caption" fontWeight="bold"  textTransform="uppercase">
                  //       International Split Order Setting
                  //     </MDTypography>
                  //   </MDBox>
                  //   <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                  //     <MDBox mt={0.5}>
                  //       <ThemeProvider theme={muiTheme}>
                  //         <Switch checked={allowSplitOrdersInter} onChange={() => setAllowSplitOrdersInter(!allowSplitOrdersInter)}/>
                  //       </ThemeProvider>
                  //     </MDBox>
                  //     <MDBox width="80%" ml={0.5}>
                  //       <MDTypography variant="button" fontWeight="regular" color="text">
                  //         Allow split orders
                  //       </MDTypography>
                  //     </MDBox>
                  //   </MDBox>
                  //   {
                  //       allowSplitOrdersInter === true &&
                  //       <MDBox>
                  //
                  //
                  //         <FormControl>
                  //           <MDTypography variant="button" fontWeight="regular" color="text">
                  //             Priority:
                  //           </MDTypography>
                  //           <ThemeProvider theme={muiTheme}>
                  //             <RadioGroup
                  //                 aria-labelledby="demo-controlled-radio-buttons-group"
                  //                 name="controlled-radio-buttons-group"
                  //                 value={splitInvPriorityInter}
                  //                 onChange={handleSplitPriorityChangeInter}
                  //             >
                  //               <FormControlLabel value="inventory_first" control={<Radio size="small"/>}
                  //                                 label={
                  //                                   <MDTypography variant="button" fontWeight="regular" color="text">
                  //                                     Inventory
                  //                                   </MDTypography>}
                  //               />
                  //               <FormControlLabel value="distance_first" control={<Radio size="small"/>}
                  //                                 label={
                  //                                   <MDTypography variant="button" fontWeight="regular" color="text">
                  //                                     Distance
                  //                                   </MDTypography>}
                  //               />
                  //             </RadioGroup>
                  //           </ThemeProvider>
                  //         </FormControl>
                  //       </MDBox>
                  //   }
                  // </MDBox>
                }
              </MDBox>

          }


        </MDBox>
        <MDBox sx={{display: "flex", justifyContent:  "flex-end" }}>
          <MDButton sx={{marginRight: "20px"}} variant="outlined" color="info"
                    onClick={() => {
                      setLoading(false)
                      setOpenSplitOrderEdit(false)
                      setAllWarehouses([])
                      dispatch(userWHMpCfgReset())
                    }}>
            {t('Cancel')}
          </MDButton>
          {
            type !== 'Preview' &&
              <LoadingButton
                  disabled={(type === 'Edit' &&!checkPermission(PERMISSION_DICT.WarehouseMappingUpdate)) ||(type === 'Add' && !checkPermission(PERMISSION_DICT.WarehouseMappingSave) )}
                  size="small"
                  loading={loading}
                  variant="contained"
                  onClick={()=>{
                    setLoading(true)
                    onSubmit()
                  }}
              >
                {t('Confirm')}
              </LoadingButton>
          }
          {
              type === 'Preview' &&
            <MDButton sx={{marginRight: "20px"}} variant="contained" color="info"
                      disabled={!checkPermission(PERMISSION_DICT.WarehouseMappingUpdate)}
                      onClick={() => {
                        // setLoading(false)
                        // setOpenSplitOrderEdit(true)
                        setType('Edit')
                      }}>
              {t('Edit')}
            </MDButton>
          }

        </MDBox>
      </Card>
  );
}

export default PlatformSettings;